import $ from 'jquery'
import Isotope from 'isotope-layout'
import imagesLoaded from 'imagesloaded'
import { debounce, getTextNodesIn } from '../functions'

imagesLoaded.makeJQueryPlugin($)

let iso = ''

const parent = $('.js-pt-faq-container')
if (parent.length) {
  iso = new Isotope('.js-pt-faq-container', {
    itemSelector: '.feed-faq',
    percentPosition: true,
    transitionDuration: 0,
    masonry: {
      columnWidth: '.pt-faq__sizer',
    },
  })

  parent.imagesLoaded(function () {
    iso.layout()
  })

  $('.js-select').on('change', function () {
    const $this = $(this)
    const val = $this.val() * 1

    if (!val) {
      iso.arrange({ filter: '*' })
      return
    }

    iso.arrange({
      filter: function () {
        const service = $(this)

        if (service.hasClass('pt-faq__sizer')) {
          return false
        }

        const attr = service.attr('data-categories')
        const domains = attr.includes(',') ? attr.split(',') : [attr]
        const newDomains = domains.map(Number)

        return newDomains.includes(val)
      },
    })

    $this.addClass('active')
  })
}

const search = $('.js-header-search').keyup(
  debounce(function () {
    const regex = new RegExp(search.val(), 'gi')

    iso.arrange({
      filter: function () {
        const text = getTextNodesIn($(this)[0])
        return regex ? text.match(regex) : true
      },
    })
  }, 200)
)
